import { Box, Grid, InputLabel, TextField, Button, ToggleButtonGroup, ToggleButton } from '@mui/material'
import { useForm, Controller } from 'react-hook-form'
import { useRrhh } from '../../../../shared/context/rrhhContext'
import { useEffect } from 'react'
export default function FilterRrhhComponent() {

    const { getRrhh } = useRrhh()


    const getSavedFormValues = () => {
        const savedForm = localStorage.getItem(`rrhh_filter`)
        if (savedForm) {
            return JSON.parse(savedForm)
        }
        return {
            num_document: '',
            fullName: '',
            position: '',
            email: '',
            is_active: "true"
        }
    }

    const { control, handleSubmit, setValue, watch } = useForm({
        defaultValues: getSavedFormValues()
    })

    const formValues = watch()
    useEffect(() => {
        localStorage.setItem(`rrhh_filter`, JSON.stringify(formValues))
    }, [formValues])

    const onSubmit = (data) => {
        getRrhh(data)
    }
    const handleClearForm = () => {
        const defaultValues = {
            num_document: '',
            fullName: '',
            position: '',
            email: '',
            phone: '',
            is_active: "true"
        }
        Object.keys(defaultValues).forEach(key => {
            setValue(key, defaultValues[key]);
        });

        getRrhh()
    }
    return (
        <Box sx={{padding: 2}}>
            <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} columns={12}>
                <Grid item size={{ xs: 12}}>
                    <InputLabel sx={{fontSize: 14, fontWeight: 600}}>N. Documento</InputLabel>
                    <Controller
                        control={control}
                        name="num_document"
                        render={({ field }) => (
                            <TextField
                                name="num_document"
                                fullWidth
                                value={field.value}
                                onChange={(e) => setValue(field.name, e.target.value)}
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12}}>
                    <InputLabel sx={{fontSize: 14, fontWeight: 600}}>Nombre</InputLabel>
                    <Controller
                        control={control}
                        name="fullName"
                        render={({ field }) => (
                            <TextField
                                name="fullName"
                                fullWidth
                                value={field.value}
                                onChange={(e) => setValue(field.name, e.target.value)}
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12}}>
                    <InputLabel sx={{fontSize: 14, fontWeight: 600}}>Cargo</InputLabel>
                    <Controller
                        control={control}
                        name="position"
                        render={({ field }) => (
                            <TextField
                                name="position" 
                                fullWidth
                                value={field.value}
                                onChange={(e) => setValue(field.name, e.target.value)}
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12}}>
                    <InputLabel sx={{fontSize: 14, fontWeight: 600}}>Email</InputLabel>
                    <Controller
                        control={control}
                        name="email"
                        render={({ field }) => (
                            <TextField
                                name="email"
                                fullWidth
                                value={field.value}
                                onChange={(e) => setValue(field.name, e.target.value)}
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12}}>
                    <InputLabel sx={{fontSize: 14, fontWeight: 600}}>Habilitado</InputLabel>
                    <Controller
                        control={control}
                        name="is_active"
                        render={({ field }) => (
                            <ToggleButtonGroup
                                value={field.value}
                                onChange={(e) => setValue(field.name, e.target.value)}
                                exclusive
                                fullWidth
                                color="primary"
                                sx={{ borderRadius: 2, height: 40, fontSize: 14, fontWeight: 600 }}
                            >
                                <ToggleButton value={"true"}>Si</ToggleButton>
                                <ToggleButton value={"false"}>No</ToggleButton>
                            </ToggleButtonGroup>
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12}}>
                    <Button variant="contained" color="primary" fullWidth size="large" type="submit"
                    sx={{ borderRadius: 2, height: 40, fontSize: 14, fontWeight: 600 }}>Buscar</Button>
                    <Button 
                        variant="contained" 
                        color="disabled" 
                        fullWidth 
                        size="large"    
                        onClick={handleClearForm}
                        sx={{ borderRadius: 2, height: 40, fontSize: 14, fontWeight: 600, mt: "5px" }}
                    >
                        Limpiar
                    </Button>
                </Grid>
                    
                    
            </Grid>
        </form>
        </Box>
    )
}
 